import React, {forwardRef, PropsWithChildren} from 'react';

import {ChromelessButtonProps} from '../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {AvatarButton} from './avatarButton';
import {TeammateAvatar, TeammateAvatarProps} from './teammateAvatar';

/*
 * Props.
 */

type TeammateAvatarButtonBaseProps = TeammateAvatarProps & ChromelessButtonProps;

interface TeammateAvatarButtonProps extends TeammateAvatarButtonBaseProps {
  hasDarkerHover?: boolean;
}

/*
 * Component.
 */

export const TeammateAvatarButton = forwardRef<HTMLDivElement, PropsWithChildren<TeammateAvatarButtonProps>>(
  (props, ref) => (
    <AvatarButton {...props} ref={ref}>
      <TeammateAvatar {...props} supportsHover />
    </AvatarButton>
  ),
);
